import _ from 'underscore';
import PropTypes from 'prop-types';
import React, { memo, useContext } from 'react';
import classNames from 'classnames';
import { I18nContext } from '@bingads-webui-react/i18n-context';
import { withDefaultStyles } from '@bingads-webui-react/with-default-styles';
import { HelpPopup } from '@bingads-webui-react/help-popup';

import { getInlineHelpStyles } from './inline-help-styles';

const InlineHelpUnstyled = memo((props) => {
  const {
    classes,
    topic,
    withoutSpace,
    ariaLabel,
  } = props;

  const i18n = useContext(I18nContext);

  return (
    <span className={classNames({
      [classes.inlineHelp]: true,
      [classes.withSpace]: !withoutSpace,
    })}
    >
      <HelpPopup
        aria-label={ariaLabel ? i18n.getString(ariaLabel) : i18n.getString(_TL_('Learn more'))}
        topic={topic}
      />
    </span>
  );
});

InlineHelpUnstyled.propTypes = {
  topic: PropTypes.string.isRequired,
  classes: PropTypes.shape(_.mapObject(
    getInlineHelpStyles({}, {}),
    _.constant(PropTypes.string.isRequired)
  )).isRequired,
  withoutSpace: PropTypes.bool,
  ariaLabel: PropTypes.string,
};

InlineHelpUnstyled.defaultProps = {
  withoutSpace: false,
  ariaLabel: null,
};

export const InlineHelp = withDefaultStyles(InlineHelpUnstyled, getInlineHelpStyles);

